// src/services/authService.js
import Cookies from 'js-cookie';

// Cookie configuration
const TOKEN_KEY = 'rlpy-token';
const cookieConfig: any = {
  expires: 1, // Expires in 1 day
  secure: window.location.protocol === 'https:', // Secure only for HTTPS
  sameSite: 'Strict', // Protects against CSRF
  path: '/', // Available for all routes
};
// Save token to cookie
export function setToken(token: string) {
  if (token) {
    Cookies.set(TOKEN_KEY, token, cookieConfig);
    return true;
  }
  return false;
}

// Get token from cookie
export function getToken() {
  return Cookies.get(TOKEN_KEY) || null;
}

// Remove token from cookie
export function removeToken() {
  Cookies.remove(TOKEN_KEY, { path: '/', sameSite: 'Strict' });
  window.location.href = "";
}

// Check if user is authenticated (i.e., token exists)
export function isAuthenticated() {
  return !!getToken();
}